module.exports = __webpack_public_path__ + "img/delete.b8e99c91.svg";